import { colors } from "./colors";

export const countdownGradients = {
  darktolight: [colors["neutral.900"], colors["neutral.800"]],
  redtopink: [colors["red.600"], colors["red.400"]],
}

export type CountdownGradientType = keyof typeof countdownGradients;